import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'

export function ParentMenu() {
  const {t} = useTranslation()

  return (
    <>
      <MenuInnerWithSub
        title={t('MENU.DOCUMENT_CENTER')}
        to=''
        menuPlacement='bottom-end'
        menuTrigger='click'
        hasArrow={true}
        fontIcon=''
      >
        <MenuItem
          title={t('MENU.DOCUMENTS')}
          to='/parent/documents'
          fontIcon='fa fa-file text-white mx-2'
        />
        <MenuItem
          title={t('LABEL.LETTERS')}
          to='/parent/letters'
          fontIcon='fa fa-note-sticky text-white mx-2'
        />
        <MenuItem
          title={t('LABEL.NOTES')}
          to='/parent/notes'
          fontIcon='fa fa-edit text-white mx-2'
        />
      </MenuInnerWithSub>

      <MenuItem title={t('MENU.COURSES')} to='/parent/courses' />
      <MenuItem title={t('LABEL.TRANSCRIPT')} to='/parent/transcript' />
      <MenuItem title={t('LABEL.INVOICES')} to='/parent/invoices' />
      <MenuItem to='/parent/meetings' title={t('MEETING.MEETINGS')} />
    </>
  )
}
